import { useBox } from '@react-three/cannon'
import React from 'react'


const Collider = ({size, position, rotation, trigger}) => {

    const [ref] = useBox(() => ({
        type : "Rigid",
        args : size,
        position : position,
        rotation : rotation,
        isTrigger : trigger? true : false,
        onCollide : () => {
            // console.log(ref.current.position)
        },
        // onCollideEnd : () => {
        //     console.log('finish')
        // }
    }))

    return (
        <mesh
            ref={ref} 
            position={position}
        >
            <boxBufferGeometry args={size}  />
            <meshBasicMaterial color={"red"} visible={false}/>
        </mesh>
    )
}

export default Collider
